module.exports = __webpack_public_path__ + "img/banner_3.8f76035c.jpg";